export const fuelTypes = {
	gasoline: 'Gasoline',
	E10: 'E10',
	E5: 'E5',
	'natural gas': 'Natural gas',
	ethane: 'Ethane',
	butane: 'Butane',
	CNG: 'CNG',
	diesel: 'Diesel',
	LNG: 'LNG',
	LPG: 'LPG',
	'petroleum gas': 'Petroleum gas',
	propane: 'Propane',
	wood: 'Wood',
	naphtha: 'Naphtha',
	coal: 'Coal',
	'coking coal': 'Coking coal',
	'petroleum coke': 'Petroleum coke',
}
